import React from "react";
import { FileText } from "lucide-react";

export default function FormPreview({ form }) {
  if (!form) return null;

  return (
    <div className="text-left">
      <h1 className="mb-8 text-2xl font-bold text-[#1D2739]">{form.name}</h1>
      {form.sections.map((section) => (
        <section key={section.id} className="mb-8">
          <h2 className="mb-2 text-lg font-semibold text-[#1D2739]">{section.title}</h2>
          <div className="mb-5 h-px w-full bg-gray-200" />
          <div className="space-y-5">
            {section.fields.map((field) => (
              <div key={field.id}>
                {field.type === "h2" && (
                  <p className="text-base font-semibold">{field.content}</p>
                )}
                {field.type === "body" && (
                  <p className="text-sm text-gray-600">{field.content}</p>
                )}
                {field.type !== "h2" && field.type !== "body" && (
                  <>
                    <label className="mb-2 block text-sm font-medium text-[#1D2739]">
                      {field.label}
                      {field.required && <span className="ml-0.5 text-red-500">*</span>}
                    </label>
                    {field.type === "text" && (
                      <input
                        readOnly
                        placeholder={field.placeholder || ""}
                        className="w-full rounded-lg bg-gray-100 px-4 py-3 text-sm outline-none"
                      />
                    )}
                    {field.type === "dropdown" && (
                      <select
                        disabled
                        className="w-full rounded-lg bg-gray-100 px-4 py-3 text-sm text-gray-500"
                        defaultValue=""
                      >
                        <option value="">Select an option</option>
                        {(field.options || []).map((opt) => (
                          <option key={opt}>{opt}</option>
                        ))}
                      </select>
                    )}
                    {field.type === "checkbox" &&
                      (field.options || []).map((opt) => (
                        <label key={opt} className="mb-1 flex items-center gap-2 text-sm">
                          <input type="checkbox" disabled />
                          {opt}
                        </label>
                      ))}
                    {(field.type === "file" || field.type === "logo") && (
                      <div className="flex items-center rounded-lg bg-gray-100 px-4 py-3">
                        <span className="flex items-center gap-2 rounded-md bg-white px-3 py-1.5 text-sm shadow-sm">
                          <FileText className="h-4 w-4" /> Choose file
                        </span>
                      </div>
                    )}
                  </>
                )}
              </div>
            ))}
          </div>
        </section>
      ))}
    </div>
  );
}
